import React from "react";
import { RECENT_ORDERS } from "../marketingData";
import { CheckIcon, LightningIcon, PlayIcon } from "../shared/icons";

const LandingHero = ({ heroVisible, heroBgRef, onSignUp, onMagneticMove, onMagneticLeave }) => (
  <>
    <div className="brand-spine-bar">
      <span>
        We built Ecomdropship because most dropshipping platforms promise fast delivery —{" "}
        <strong>but no one is enforcing it.</strong>
      </span>
    </div>

    <section className="hero" id="hero" style={{ maxWidth: "100%", padding: 0 }}>
      <div className={`hero-bg-img${heroVisible ? " loaded" : ""}`} id="heroBg" ref={heroBgRef} />
      <div className="hero-overlay" />
      <div className="hero-grid-lines" />
      <div className="hero-content">
        <div className="hero-left">
          <h1 className={`hero-h1${heroVisible ? " visible" : ""}`} id="heroH1">
            Your supplier problems end right here.
          </h1>
          <p className={`hero-p${heroVisible ? " visible" : ""}`} id="heroP">
            You&apos;ve already proven your store works. The problem was never your product. It was
            suppliers who failed to meet shipping expectations, charged you after cancellations, and
            left your customers waiting. Ecomdropship is built for sellers who are done experimenting
            and ready to scale with systems that actually hold.
          </p>
          <div className={`hero-btns${heroVisible ? " visible" : ""}`} id="heroBtns">
            <a
              className="btn-hero-primary"
              href="#pricing"
              onMouseMove={onMagneticMove}
              onMouseLeave={onMagneticLeave}
            >
              <LightningIcon />
              Start free trial
            </a>
            <a className="btn-hero-secondary" href="#how">
              <PlayIcon />
              See how it works
            </a>
          </div>
          <div className={`hero-trust${heroVisible ? " visible" : ""}`} id="heroTrust">
            {["No hidden fees", "3–5 day US shipping", "Cancel anytime"].map((label) => (
              <div className="trust-item" key={label}>
                <div className="trust-check">
                  <CheckIcon />
                </div>
                <span>{label}</span>
              </div>
            ))}
          </div>
        </div>
        <div className={`hero-right${heroVisible ? " visible" : ""}`} id="heroRight">
          <div className="dashboard-card">
            <div className="dash-bar">
              <span style={{ fontSize: 12, fontWeight: 600, color: "#888" }}>
                Live fulfillment dashboard
              </span>
              <div className="dash-bar-dots">
                <div className="dot" style={{ background: "#ff5f57" }} />
                <div className="dot" style={{ background: "#febc2e" }} />
                <div className="dot" style={{ background: "#28c840" }} />
              </div>
            </div>
            <div className="dash-metrics-grid">
              <div className="dash-metric">
                <div className="dm-l">On-time rate</div>
                <div className="dm-v g">98.2%</div>
                <div className="dm-s">Last 30 days</div>
              </div>
              <div className="dash-metric">
                <div className="dm-l">Avg ship time</div>
                <div className="dm-v o">3.5d</div>
                <div className="dm-s">US orders</div>
              </div>
              <div className="dash-metric">
                <div className="dm-l">Active orders</div>
                <div className="dm-v">1,284</div>
                <div className="dm-s">In transit</div>
              </div>
            </div>
            <div className="dash-orders">
              <div className="dash-orders-head">
                <span className="dash-orders-title">Recent orders</span>
                <span className="dash-orders-link">View all →</span>
              </div>
              {RECENT_ORDERS.map((order) => (
                <div className="order-row" key={order.id}>
                  <span className="order-id">{order.id}</span>
                  <span className="order-dest">{order.dest}</span>
                  <span className={`order-status ${order.statusClass}`}>{order.status}</span>
                  <span className="order-time">{order.time}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="notif-float">
            <div className="notif-icon-box">
              <CheckIcon />
            </div>
            <div className="notif-texts">
              <div className="notif-title">Order #5821 delivered on time</div>
              <div className="notif-sub">3 days — supplier score: 99%</div>
            </div>
          </div>
        </div>
      </div>
      <div className="hero-scroll-hint" id="scrollHint" style={{ opacity: heroVisible ? 1 : 0 }}>
        <span className="scroll-text">Scroll</span>
        <div className="scroll-line" />
      </div>
    </section>
  </>
);

export default LandingHero;
